export function getClubByName (state) {
	return name => state.clubs.find(club => club.name === name);
}
